import {generateAsyncActionCreators} from '../core/reduxUtils';

const getAbTestActionCreators = generateAsyncActionCreators(
  'GET_AB_TEST',
  (params) => ({
    params,
  })
);

const setAbTestState = (newState) => ({
  type: 'SET_AB_TEST_STATE',
  payload: newState,
});

const actionCreators = {
  getAbTest: {
    ...getAbTestActionCreators,
  },
  setAbTestState
};

export {
  actionCreators,
  getAbTestActionCreators,
  setAbTestState
};
